"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEvents = void 0;
exports.customEvents = {
    customerTokenUpdated: 'customer:updated_token',
};
